import { buttonThemes as Button } from "./button";
export const components = {
  Button,
};
